import React, {ReactElement} from 'react';
import {Pages} from '../../assets/ts/customTypes';
/* navi icons */
import { ReactComponent as TeileidentifikationNaviIcon } from '../../assets/icons/navi/teileidentifikation.svg';
import { ReactComponent as KatalogschnittstelleNaviIcon } from '../../assets/icons/navi/katalogschnittstelle.svg';
import { ReactComponent as LagerergaenzungNaviIcon } from '../../assets/icons/navi/lagerergaenzung.svg';
import { ReactComponent as NettopreisschnittstelleNaviIcon } from '../../assets/icons/navi/nettopreisschnittstelle.svg';
import { ReactComponent as VerfuegbarkeitsschnittstelleNaviIcon } from '../../assets/icons/navi/verfuegbarkeitschnittstelle.svg';
import { ReactComponent as BestellschnittstelleNaviIcon } from '../../assets/icons/navi/bestellschnittstelle.svg';
/* landingpage icons */
import TeileidentifikationMapIcon from '../../assets/icons/map/teileidentifikation.svg';
import KatalogschnittstelleMapIcon from '../../assets/icons/map/katalogschnittstelle.svg';
import LagerergaenzungMapIcon from '../../assets/icons/map/lagerergaenzung.svg';
import NettopreisschnittstelleMapIcon from '../../assets/icons/map/nettopreisschnittstelle.svg';
import VerfuegbarkeitsschnittstelleMapIcon from '../../assets/icons/map/verfuegbarkeitschnittstelle.svg';
import BestellschnittstelleMapIcon from '../../assets/icons/map/bestellschnittstelle.svg';
/* content icons */

interface NavIconProps {
    page: Pages;
    type: 'map' | 'navi';
}

type IconsType = {
    [Pages: string]: {
        map: ReactElement,
        navi: ReactElement,
    }
}

const icons: IconsType = {
    [Pages.TEILEIDENTIFIKATION]: {
        map: svgWrap(TeileidentifikationMapIcon),
        navi: <TeileidentifikationNaviIcon />,
    },
    [Pages.LAGERERGAENZUNG]: {
        map: svgWrap(LagerergaenzungMapIcon),
        navi: <LagerergaenzungNaviIcon />,
    },
    [Pages.KATALOGSCHNITTSTELLE]: {
        map: svgWrap(KatalogschnittstelleMapIcon),
        navi: <KatalogschnittstelleNaviIcon />,
    },
    [Pages.NETTOPREISSCHNITTSTELLE]: {
        map: svgWrap(NettopreisschnittstelleMapIcon),
        navi: <NettopreisschnittstelleNaviIcon />,
    },
    [Pages.BESTELLSCHNITTSTELLE]: {
        map: svgWrap(BestellschnittstelleMapIcon),
        navi: <BestellschnittstelleNaviIcon />,
    },
    [Pages.VERFUEGBARKEITSSCHNITTSTELLE]: {
        map: svgWrap(VerfuegbarkeitsschnittstelleMapIcon),
        navi: <VerfuegbarkeitsschnittstelleNaviIcon />,
    },
};

export const Icon = ({page, type}: NavIconProps) => {
    return icons[page][type];
}

function svgWrap(svg: string) {
    return (
        <object type='image/svg+xml' data={svg}></object>
    );
}